__turbopack_context__.v({
  "herosectionImageBox": "OnlineLoadBooking-module-scss-module__w6qgNG__herosectionImageBox",
  "main": "OnlineLoadBooking-module-scss-module__w6qgNG__main",
});
